import api from './axios'

/**
 * Get all teams with filters
 * @param {object} params - Filter parameters
 * @returns {Promise<{data: Array, pagination: object}>}
 */
export const getTeams = async (params = {}) => {
  const response = await api.get('/teams', { params })
  return response.data
}

/**
 * Get single team by ID
 * @param {number} id 
 * @returns {Promise<object>}
 */
export const getTeam = async (id) => {
  const response = await api.get(`/teams/${id}`)
  return response.data
}

/**
 * Get team with full details
 * @param {number} id 
 * @returns {Promise<object>}
 */
export const getTeamFull = async (id) => {
  const response = await api.get(`/teams/${id}/full`)
  return response.data
}

/**
 * Create new team
 * @param {object} teamData 
 * @returns {Promise<object>}
 */
export const createTeam = async (teamData) => {
  const response = await api.post('/teams', teamData)
  return response.data
}

/**
 * Update team
 * @param {number} id 
 * @param {object} teamData 
 * @returns {Promise<object>}
 */
export const updateTeam = async (id, teamData) => {
  const response = await api.put(`/teams/${id}`, teamData)
  return response.data
}

/**
 * Delete team
 * @param {number} id 
 * @returns {Promise<void>}
 */
export const deleteTeam = async (id) => {
  const response = await api.delete(`/teams/${id}`)
  return response.data
}

/**
 * Get team's trainers
 * @param {number} id 
 * @returns {Promise<Array>}
 */
export const getTeamTrainers = async (id) => {
  const response = await api.get(`/teams/${id}/trainers`)
  return response.data
}